var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.links),function(link){return _c('v-list-item',{key:link.text,on:{"click":function($event){return _vm.redirectUser(link.route)}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(link.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(link.text)+" ")])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }